<div *ngIf="loadComplete" class="container-block">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center"
      (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>

    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'"
      class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <!-- Option màu nền cho frame -->
      <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config"
        [class]="class" [backgroundClass]="class['frame-products']" [backgroundConfig]="config['frame-products']"
        [isBlock]="false" [id_object]="objectChoosing._id" [device]="device">
      </app-background-image-config>
      <div class="mr-2 mb-4 mt-4 view-more" style="
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 7px;
  " *ngIf="config['frame-products'].option_background == 'color'">
        <p class="discover_text" (click)="openViewAll(stylesField[5])"
          style="cursor: pointer; text-align: left; margin: 0">
          {{'mo_rong' | translate}} &#8594;
        </p>
      </div>

      <app-total-row-col-products-config [objectChoosing]="objectChoosing" [config]="config" [class]="class"
        [productsClass]="class['frame-products__products']" [productsConfig]="config['frame-products__products']"
        [id_object]="objectChoosing._id" [device]="device">
      </app-total-row-col-products-config>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình tái sử dụng thiết kế-->

      <!-- Cấu hình thông số cơ bản -->
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <!-- Option màu nền cho frame -->
          <app-background-image-config [showImageConfig]="false" [config]="config" [class]="class"
            [backgroundClass]="class['frame-products']" [backgroundConfig]="config['frame-products']" [isBlock]="false"
            [id_object]="objectChoosing._id" [device]="device">
          </app-background-image-config>
          <!-- kieu_hien_thi(slide, pagination) -->
          <div class="item">
            <div class="title-font d-flex align-items-center">{{'kieu_hien_thi'| translate}}</div>
            <nz-select style="width: 100px" [(ngModel)]="config.type_display" (ngModelChange)="updateTypeDisplay()">
              <nz-option [nzValue]="'slide'" nzLabel="{{'vuot' | translate}}"></nz-option>
              <nz-option [nzValue]="'pagination'" nzLabel="{{'phan_trang'| translate}}"></nz-option>
              <nz-option [nzValue]="'resize'" nzLabel="{{'gian_ra_theo_noi_dung'| translate}}"></nz-option>
            </nz-select>
          </div>
          <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          " *ngIf="config['frame-products'].option_background == 'color'">
            <p class="discover_text" (click)="openViewAll(stylesField[5])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>

          <!-- Thay đổi màu thẻ chứa cụm nút phân trang-->
          <div *ngIf="config.type_display == 'pagination'" class="config-name">
            <p>{{'mau_nen_cum_nut_phan_trang' | translate}}</p>
            <input class="input-color"  type="button"
              [style.background]="class['frame-products__pagination']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-products__pagination']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <!-- Cho phép slide -->
          <ng-container *ngIf="config.type_display == 'slide'">
            <app-slide-config  [elementChoosing]="objectChoosing" [config]="config" [class]="class" [slideConfig]="config['frame-products__products']"
              [id_object]="objectChoosing._id" [device]="device">
            </app-slide-config>

            <div class="config-name title" style="margin-bottom: 15px;">
              <p>{{'cho_phep_tran_vien' | translate}}</p>
              <nz-switch [ngModel]="class['frame-products']['overflow'] == 'visible'" (ngModelChange)="$event ? class['frame-products']['overflow'] = 'visible' : class['frame-products']['overflow'] = 'hidden'; updateClass();"></nz-switch>
            </div>
          </ng-container>
        </div>
      </li>
      <!-- Cấu hình icon bên trái -->
      <li *ngIf="config['frame-products__products']['is_autoplay'] || config['frame-products__products']['is_slide']"
        nz-submenu nzTitle="{{'cau_hinh_icon_trai' | translate}}" [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <app-icon-left-config [device]="device" [class]="class" [config]="config"
          [iconLeftClass]="class['frame-products__left-arrow--icon']"
          [iconLeftConfig]="config['frame-products__left-arrow--icon']"
          [distanceLeftClass]="class['frame-products__left-arrow']" [id_object]="objectChoosing._id">
        </app-icon-left-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[2])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình icon bên phải -->
      <li *ngIf="config['frame-products__products']['is_autoplay'] || config['frame-products__products']['is_slide']"
        nz-submenu nzTitle="{{'cau_hinh_icon_phai' | translate}}" [(nzOpen)]="openMenu.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-icon-right-config [device]="device" [class]="class" [config]="config"
          [iconRightClass]="class['frame-products__right-arrow--icon']"
          [iconRightConfig]="config['frame-products__right-arrow--icon']"
          [distanceRightClass]="class['frame-products__right-arrow']" [id_object]="objectChoosing._id">
        </app-icon-right-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[3])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình chung -->
      <li nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}" [(nzOpen)]="openMenu.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-total-row-col-products-config [config]="config" [class]="class"
          [productsClass]="class['frame-products__products']" [productsConfig]="config['frame-products__products']"
          [id_object]="objectChoosing._id" [device]="device">
        </app-total-row-col-products-config>

        <!-- Khoảng đệm -->
        <div>
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-products__products']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="{{'cau_hinh_phan_tu' | translate}}" [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p class="w-50">{{'mau_nen' | translate}}</p>
            <input class="input-color w-50" type="button"
              [style.background]="class['frame-products__products--item']['background-color']" [cpOKButton]="true"
              [(colorPicker)]="class['frame-products__products--item']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
            <p class="discover_text" (click)="openViewAll(stylesField[6])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>

          <app-borders-config [device]="device" [class]="class" [borderClass]="class['frame-products__products--item']"
            [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
          </app-borders-config>

          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Cấu hình khi không tìm thấy sản phẩm -->
      <li nz-submenu nzTitle="{{'cau_hinh_khi_khong_tim_thay_san_pham' | translate}}" [(nzOpen)]="openMenu.menu13"
        (nzOpenChange)="openHandler('menu13')">
        <div class="d-flex justify-content-between align-items-center p-3">
          <p>{{'cau_hinh' | translate}}</p>
          <nz-switch [(ngModel)]="config['is_empty']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <ng-container *ngIf="config['is_empty']">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">

          </div>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata['no_data_' + functionService.selectedLanguageCode] | vhLanguage : 'no_data' : objectChoosing.component"
                (ngModelChange)="objectChoosing.staticdata['no_data_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing"
            [staticdata]="objectChoosing.staticdata" [class]="class" [config]="config"
            [textContentClass]="class['frame-products-viewed__no-data']"
            [textWrapperClass]="class['frame-products-viewed__no-data']">
          </app-text-format-config>

          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                      class['frame-products-viewed__no-data']['letter-spacing'] | vhnumber
                    " (nzBlur)="updateClass()" (ngModelChange)="
                      class['frame-products-viewed__no-data']['letter-spacing'] = $event + 'px'
                    "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30"
              [ngModel]="class['frame-products-viewed__no-data']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                    class['frame-products-viewed__no-data']['letter-spacing'] = $event + 'px'
                  "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> {{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['frame-products-viewed__no-data']['line-height']"
                (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
              [(ngModel)]="class['frame-products-viewed__no-data']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </ng-container>
      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['frame-products']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>

      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMenu.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)" [id_object]="objectChoosing._id" [device]="device"
          [class]="class" [config]="config" [staticdata]="objectChoosing.staticdata"
          [cursorClass]="class['frame-products']" [effect_hover]="effect_hover" [customize]="customize"
          [effectFileUsing]="'frame-products'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-products']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-products__products--item']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

      <!-- Bật đổ bóng -->
      <app-shadow-config [device]="device" [config]="config" [class]="class"
        [shadowClass]="class['frame-products__products--item']"
        [shadowConfig]="config['frame-products__products--item']" [objectChoosing]="objectChoosing">
      </app-shadow-config>
    </div>
    <!-- Icon slide trái -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <!-- Kích thước nút (chiều cao) -->
      <div>
        <div class="config-name">
          <p>{{'kich_thuoc_nut_(_chieu_rong_)' | translate}} </p>
          <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
            [ngModel]="class['frame-products__left-arrow--icon']['width'] | vhnumber"
            (ngModelChange)="class['frame-products__left-arrow--icon']['width'] = $event+'px';"
            (nzBlur)="updateClass()">
          </nz-input-number>
        </div>
        <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
          [ngModel]="class['frame-products__left-arrow--icon']['width'] | vhnumber"
          (ngModelChange)="class['frame-products__left-arrow--icon']['width'] = $event+'px';"
          (nzOnAfterChange)="updateClass()">
        </nz-slider>
      </div>
      <!-- Kích thước nút (chiều cao) -->
      <div>
        <div class="config-name">
          <p>{{'kich_thuoc_nut_(_chieu_cao_)' | translate}} </p>
          <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
            [ngModel]="class['frame-products__left-arrow--icon']['height'] | vhnumber"
            (ngModelChange)="class['frame-products__left-arrow--icon']['height'] = $event+'px';"
            (nzBlur)="updateClass()">
          </nz-input-number>
        </div>
        <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
          [ngModel]="class['frame-products__left-arrow--icon']['height'] | vhnumber"
          (ngModelChange)="class['frame-products__left-arrow--icon']['height'] = $event+'px';"
          (nzOnAfterChange)="updateClass()">
        </nz-slider>
      </div>

      <!-- Viền -->
      <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderClass]="class['frame-products__left-arrow--icon']" [id_object]="objectChoosing._id">
      </app-borders-config>

      <!-- Bo tròn -->
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-products__left-arrow--icon']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

      <!-- Đổ bóng -->
      <app-shadow-config [device]="device" [config]="config" [class]="class"
        [shadowClass]="class['frame-products__left-arrow--icon']" [shadowConfig]="config['left_arrow_icon_shadow']"
        [objectChoosing]="objectChoosing">
      </app-shadow-config>
    </div>
    <!-- Icon slide phải -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <!-- Kích thước nút (chiều cao) -->
      <div>
        <div class="config-name">
          <p>{{'kich_thuoc_nut_(_chieu_rong_)' | translate}} </p>
          <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
            [ngModel]="class['frame-products__right-arrow--icon']['width'] | vhnumber"
            (ngModelChange)="class['frame-products__right-arrow--icon']['width'] = $event+'px';"
            (nzBlur)="updateClass()">
          </nz-input-number>
        </div>
        <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
          [ngModel]="class['frame-products__right-arrow--icon']['width'] | vhnumber"
          (ngModelChange)="class['frame-products__right-arrow--icon']['width'] = $event+'px';"
          (nzOnAfterChange)="updateClass()">
        </nz-slider>
      </div>
      <!-- Kích thước nút (chiều cao) -->
      <div>
        <div class="config-name">
          <p>{{'kich_thuoc_nut_(_chieu_cao_)' | translate}} </p>
          <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
            [ngModel]="class['frame-products__right-arrow--icon']['height'] | vhnumber"
            (ngModelChange)="class['frame-products__right-arrow--icon']['height'] = $event+'px';"
            (nzBlur)="updateClass()">
          </nz-input-number>
        </div>
        <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
          [ngModel]="class['frame-products__right-arrow--icon']['height'] | vhnumber"
          (ngModelChange)="class['frame-products__right-arrow--icon']['height'] = $event+'px';"
          (nzOnAfterChange)="updateClass()">
        </nz-slider>
      </div>

      <!-- Viền -->
      <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderClass]="class['frame-products__right-arrow--icon']" [id_object]="objectChoosing._id">
      </app-borders-config>

      <!-- Bo tròn -->
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-products__right-arrow--icon']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

      <!-- Đổ bóng -->
      <app-shadow-config [device]="device" [config]="config" [class]="class"
        [shadowClass]="class['frame-products__right-arrow--icon']" [shadowConfig]="config['right_arrow_icon_shadow']"
        [objectChoosing]="objectChoosing">
      </app-shadow-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 5">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="objectChoosing.staticdata"
        [id_object]="objectChoosing._id" [customize]="customize" [device]="device"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 6 || currentViewAll.index == 7">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox
          [(ngModel)]="config['background-color' + (currentViewAll.index == 6 ? '' : '-item')].gradient_check"
          (ngModelChange)="updateBackgroundRgb(currentViewAll.index - 1)"></label>
      </div>
      <ng-container *ngIf="config['background-color' + (currentViewAll.index == 6 ? '' : '-item')]?.gradient_check">
        <div class="list-gradient">
          <button class="btn-gradient" *ngFor="
              let bgGradient of config['background-color' + (currentViewAll.index == 6 ? '' : '-item')]['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i, (currentViewAll.index - 1))" [ngStyle]="{ 'background-color': bgGradient }"
            [disabled]="!config['background-color' + (currentViewAll.index == 6 ? '' : '-item')].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
          </button>
        </div>
        <p class="title-head">{{'them_mau' | translate}}</p>
        <div class="container_add-gradient">
          <input class="input-color" [cpOKButton]="true" type="button"
            [(colorPicker)]="config['background-color' + (currentViewAll.index == 6 ? '' : '-item')]['background']"
            [disabled]="!config['background-color' + (currentViewAll.index == 6 ? '' : '-item')].gradient_check"
            [style.background]="config['background-color' + (currentViewAll.index == 6 ? '' : '-item')]['background']"
            (colorPickerClose)="addGradient($event, (currentViewAll.index - 1))" />
        </div>
        <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
        <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
          nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, (currentViewAll.index - 1))"
          [class.active]="config['background-color' + (currentViewAll.index == 6 ? '' : '-item')]['gradient_direction'] === type.direction"
          [disabled]="!config['background-color' + (currentViewAll.index == 6 ? '' : '-item')].gradient_check"
          [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'">
        </button>
      </ng-container>
    </div>
  </div>
</div>